var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
// DO NOT EDIT IT MANUALLY
import { FAMILY, PURPOSE, SIZE } from '../../constants';
import { Typography } from '../../Typography';
export function MonoHeadlineM(_a) {
    var { className, children, tag } = _a, rest = __rest(_a, ["className", "children", "tag"]);
    return (_jsx(Typography, Object.assign({}, rest, { family: FAMILY.Mono, purpose: PURPOSE.Headline, size: SIZE.M, tag: tag, className: className, children: children })));
}
